import { render, staticRenderFns } from "./ThrifterPreview.vue?vue&type=template&id=a4ff020a&scoped=true&"
import script from "./ThrifterPreview.vue?vue&type=script&lang=js&"
export * from "./ThrifterPreview.vue?vue&type=script&lang=js&"
import style0 from "./ThrifterPreview.vue?vue&type=style&index=0&id=a4ff020a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ff020a",
  null
  
)

export default component.exports